import type { SearchActionPlansQuery } from '@predium/client-graphql';
import { useEntitySearch } from '@/components/global-search/hooks/useEntitySearch';
import { getActionPlanItems } from '@/components/global-search/utils';
import { SEARCH_ACTION_PLANS } from '@/graphql/ActionPlanning.queries';

type ActionPlan = SearchActionPlansQuery['action_plan'][0];

const actionPlanDataExtractor = (data: SearchActionPlansQuery | undefined): ActionPlan[] => data?.action_plan ?? [];

export function useSearchActionPlan(searchText: string) {
  const { data, loading, error } = useEntitySearch<SearchActionPlansQuery, ActionPlan>({
    query: SEARCH_ACTION_PLANS,
    dataExtractor: actionPlanDataExtractor,
    searchText,
  });

  return {
    actionPlans: getActionPlanItems(data),
    loading,
    error,
  };
}
